<template>
    <div class="entity-question">
        <div v-if="!questionId" class="check-question" @click="openSelectQuestionModal">选择关联标问 <i class="el-icon-top-right"></i></div>
        <div v-else>
            <el-input disabled v-model="questionDetail" placeholder="请输入内容"></el-input>
            <div class="check-question" @click="openSelectQuestionModal">替换关联标问 <i class="el-icon-top-right"></i></div>
        </div>
    </div>
</template>

<script>
import i18n from "@/i18n";

export default {
    name: "EntityQuestion",
    model: {
        prop: "questionId",
        event: "change",
    },
    props: ["questionId", "questionDetail"],
    components: {},
    data() {
        return {}
    },
    methods: {
        openSelectQuestionModal() {
            // 打开选择标问弹窗
            this.$store.dispatch("zhiji/showModal", {
                type: "QuestionSelectorTableModal",
                data: {
                    title: i18n.t("zhiji.answer.textWidget.linkQuestion"),
                    questionId: parseInt(this.questionId),
                    currentLang: this.$store.state.zhiji.gameState.defaultLang,
                    confirm: data => {
                        const questionDetail = `${data.questionId}-${data.question}`;
                        this.$emit("change", data.questionId);
                        this.$emit("changeQuestion", questionDetail);
                    },
                    langDisabled: true,
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
.entity-question {
    width: 100%;
    i {
        font-weight: 800;
    }
    .check-question {
        margin-top: 5px;
        cursor: pointer;
        color: #2ec2ff;
    }
}

</style>